module.exports = __webpack_public_path__ + "static/autocomplete-suggestions-7bce84a127daae3cfe252ebc3922bea3.png";